import { Tooltip } from '@iwoca/orion';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './LinkDebitCard.module.css';
import { stripeElementStyles } from './StripeElementStyles';

export const CVVQuestion = ({
    error,
    onFocus,
    onBlur,
    onChange
}: {
    error: boolean | null;
    onFocus?: () => void;
    onBlur?: () => void;
    onChange: (field: StripeCardCvcElementChangeEvent) => void;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.CVVWrapper}>
            <label className={styles.label}>
                <FormattedMessage
                    id="_.link_debit_card.cvv"
                    defaultMessage="CVC"
                />
                <Tooltip
                    dataTestId="cvvHelpTooltip"
                    placement="top"
                    content={intl.formatMessage({
                        id: '_.link_debit_card.cvv_number_tooltip',
                        defaultMessage:
                            'The 3 digit number on the back of your card'
                    })}
                />
            </label>

            {error && (
                <span className={styles.error}>
                    <FormattedMessage
                        id="_.link_debit_card.cvv_error"
                        defaultMessage="Invalid CVC"
                    />
                </span>
            )}
            <CardCvcElement
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                options={{
                    style: stripeElementStyles
                }}
            />
        </div>
    );
};
